export const state = () => ({
  shouldFullSync: false,
  last: null,
  entries: [],
  events: [],
  device: null,
  lastClear: null,
  running: false,
  failed: false,
})

export const getters = {
  top: state => count => state.entries.filter((_, i) => i < count),
}

export const mutations = {
  pushEvent: (state, entry) =>
    Object.assign(
      state,
      {}
      // state.events.length >= 100 ? {} : { events: [...state.events, entry] }
    ),
  push: (state, payload) => {
    const entry = { ...payload, events: state.events }
    Object.assign(state, {
      entries: [/* ...state.entries, */ entry],
      last: entry,
      events: [],
    })
  },
  setFailed: (state, failed) => Object.assign(state, { failed }),
  reset: state =>
    Object.assign(state, {
      entries: [],
      events: [],
      lastClear: new Date().toISOString(),
    }),
  clear: state =>
    Object.assign(state, {
      entries: [],
      lastClear: new Date().toISOString(),
      failed: false,
    }),
  popEntries: (state, count) =>
    Object.assign(
      state,
      {
        entries: state.entries.filter((_, i) => i >= count),
        failed: false,
      },
      state.entries.length <= count
        ? { lastClear: new Date().toISOString() }
        : {}
    ),
  setDevice: (state, device) => Object.assign(state, { device }),
  setFullSync: (state, shouldFullSync) =>
    Object.assign(state, { shouldFullSync }),
  running: (state, running) => Object.assign(state, { running }),
}
